import { IPostUserData } from '../../types/user';
import { axiosInstance } from '../axiosInstance';

export const login = async (data: {
  email: string;
  password: string;
}): Promise<IPostUserData> => {
  const response = await axiosInstance.post(`/users/login`, data, {
    withCredentials: true,
  });
  return response.data;
};
